module.exports = __webpack_public_path__ + "img/Character_Barbara_Thumb.8b0a61c6.png";